import { axiosClient } from '@services/clients'

export async function getCurrencies() {
  const {
    data: { result },
  } = await axiosClient('/currencies')

  return result
}
